import React, { useEffect, useRef, useState } from 'react';
import './payment.scss';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import { IPaymentProps } from './paymentinterface';
import { useSelector } from "react-redux";
import { selectors as headerSelector } from "../../../state/features/header";
import partsservice from '../../../services/partsservice';
import helperfunctions from '../../../utils/helperfunctions';
import { ICartContextType } from '../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';
import { useCartContext } from '../../ShoppingCart/shoppingcart';
import BillingInfo from './BillingInfo';
import { Error } from "@progress/kendo-react-labels";
import { TreeviewDropdown } from '../../CommonComponent';
import Alerts from '../../Alerts';
import { CARDTYPE, PAYMENTMETHOD } from '../../../const/enum';
import Loader from '../../Loader';
import {
    selectors as dropshipSelector
} from "../../../state/features/orderdetail";
const Payment = (props: IPaymentProps) => {
    const { t } = useTranslation();
    const { stepperDetails }: ICartContextType = useCartContext();
    const [paymentDetails, setPaymentDetails] = useState<any>({});
    const [creditCardUrl, setCreditCardUrl] = useState<any>({ loading: false, data: '' });
    const [showAlert, setShowAlert] = useState<any>(false);
    const [errorSuccessMessage, setErrorSuccessMessage] = useState<any>("");
    const [alertType, setAlertType] = useState<any>("");
    const [paymentOption, setPaymentOption] = useState<any>({ loading: false, data: {} });
    const [customerCreditWarning, setCustomerCreditWarning] = useState<any>({ loading: false, data: {} });
    const [creditCardList, setCreditCardList] = useState<any>({ loading: false, data: [] });
    const [creditCardDetailNew, setCreditCardDetailNew] = useState<any>();
    const [isValidCard, setIsValidCard] = useState<any>(true);
    const [isLoading, setIsLoading] = useState<any>(false);
    const [isPoNumberRequired, setIsPoNumberRequired] = useState<any>(false);
    const paymentDiv = useRef<any>(null);

    useEffect(() => {
        if (paymentDiv) {
            props?.getDivRef(paymentDiv, 'paymentDiv')
        }
    }, [paymentDiv])

    useEffect(() => {
        if (stepperDetails?.payment && Object.keys(stepperDetails?.payment)) {
            setPaymentDetails({ ...stepperDetails?.payment })
        } else {
            setPaymentDetails({ ...stepperDetails?.payment, "invalidCard": isValidCard });
        }
    }, []);

    const { headercurrentuser: { azureADId, isGuestUser } }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
    }));

    const {
        enableDropshipFlag
    }: any = useSelector((state) => ({
        enableDropshipFlag: dropshipSelector.enableDropshipFlag(state)
    }));

    useEffect(() => {
        const payment = stepperDetails?.payment ?? {};
        if (props.cartsDetails?.cart?.cartId > 0) {
            getPaymentOption();
        }
        if (payment?.creditCardProfileId > 0) {
            getCreditCardList();
        }
    }, [props?.cartsDetails?.cart?.cartId])

    useEffect(()=>{
        if((stepperDetails?.payment?.paymentMethod == PAYMENTMETHOD[PAYMENTMETHOD.KC]) && (stepperDetails?.payment?.creditCardOption == CARDTYPE.NEWCARD)){
            getCreditCardAddUrl();
        }
    },[]);

    useEffect(() => {
        const payment = stepperDetails?.payment ?? {};
        let requiredFields = ['paymentMethod', 'creditCardProfileId', 'poNumber', 'addressId', 'firstName', 'lastName', 'address1', 'address2', 'city', 'countryName', 'stateName', 'postalCode'];
        requiredFields.forEach((field:any) => {
            if ((field == "creditCardProfileId" && payment?.[field] > 0) || payment?.[field]) {
                payment['error'] = { ...payment?.error, [field]: false };
            }
        });
        if (props?.updateStepperDetails) {
            props.updateStepperDetails({ ...stepperDetails, payment: payment, isPoNumberRequired: isPoNumberRequired });
        }
        setPaymentDetails(payment)
    }, [stepperDetails?.payment])


    const handleErrorClose = () => {
        setShowAlert(false);
        setErrorSuccessMessage("");
        setAlertType("");
    }

    const getCreditCardAddUrl = () => {
        setCreditCardUrl({ loading: true, data: '' });
        partsservice.getCreditCardUrl().then((response: any) => {
            setCreditCardUrl({ loading: false, data: response.cardUrl });
        })
            .catch((e: any) => {
                setCreditCardUrl({ loading: true, data: '' });
                helperfunctions.showErrorMessage(e);
            });
    }

    const getPaymentOption = () => {
        setPaymentOption({ loading: true, data: {} });
        partsservice.getPaymentOption(azureADId, props.cartsDetails?.cart?.cartId, isGuestUser)
            .then((response: any) => {
                setPaymentOption({ loading: false, data: response ?? {} });
                setIsPoNumberRequired(response?.isPoNumberRequired);
                if (props?.updateStepperDetails) {
                    props.updateStepperDetails({ ...stepperDetails, isPoNumberRequired: response?.isPoNumberRequired })
                }
            })
            .catch((e: any) => {
                setPaymentOption({ loading: false, data: {} });
                helperfunctions.showErrorMessage(e);
            });
    }

    const getCreditCardList = (paymentObj: any = {}) => {
        setCreditCardList({ loading: true, data: [] });
        partsservice.getCreditCardList(azureADId)
            .then((response: any) => {
                setCreditCardList({ loading: false, data: response ?? [] });
                if (paymentObj?.paymentMethod == PAYMENTMETHOD[PAYMENTMETHOD.KC]) {
                    updatePaymentDetails({ ...paymentObj, "creditCardOption": (response?.length && !isGuestUser) ? null : CARDTYPE.NEWCARD })
                }
            })
            .catch((e: any) => {
                setCreditCardList({ loading: false, data: [] });
                helperfunctions.showErrorMessage(e);
                if (paymentObj?.paymentMethod == PAYMENTMETHOD[PAYMENTMETHOD.KC]) {
                    updatePaymentDetails({ ...paymentObj, "creditCardOption": CARDTYPE.NEWCARD })
                }
            });
    }

    const getCustomerCreditWarning = () => {
        setCustomerCreditWarning({ loading: true, data: {} });
        partsservice.getCustomerCreditWarning(azureADId, props.cartsDetails?.cart?.cartId)
            .then((response: any) => {
                setCustomerCreditWarning({ loading: false, data: response ?? {} });
            })
            .catch((e: any) => {
                setCustomerCreditWarning({ loading: false, data: {} });
                helperfunctions.showErrorMessage(e);
            });
    }

    const onPaymentMethodChange = (event: any) => {
        let paymentObj = { ...paymentDetails, "paymentMethod": event.target.value }
        if (event.target.value == PAYMENTMETHOD[PAYMENTMETHOD.KC] && creditCardList.data.length == 0) {
            getCustomerCreditWarning();
            if (isGuestUser) {
                paymentObj = { ...paymentObj, "creditCardOption": CARDTYPE.NEWCARD };
                updatePaymentDetails({ ...paymentObj })
            } else {
                getCreditCardList(paymentObj);
            }
            getCreditCardAddUrl();
        } else {
            updatePaymentDetails({ ...paymentObj })
        }
    }

    const onChangePoNumber = (event: any) => {
        updatePaymentDetails({ ...stepperDetails?.payment, "poNumber": event.target.value })
    }

    const updatePaymentDetails = (data: any) => {
        setPaymentDetails(data);
        if (props?.updateStepperDetails) {
            props.updateStepperDetails({ ...stepperDetails, payment: { ...stepperDetails?.payment, ...data } });
        }
    }

    const onCreditCardOptionChange = (event: any) => {
        handleErrorClose();
        if (event.target.value == CARDTYPE.NEWCARD) {
            getCreditCardAddUrl();
        }
        updatePaymentDetails({ ...stepperDetails?.payment, "creditCardOption": event.target.value });
    }

    const onCreditCardSelect = (value: any) => {
        setIsValidCard(true);
        updatePaymentDetails({
            ...stepperDetails?.payment,
            creditCardProfileId: value
        });
    }

    useEffect(() => {
        const handleMessage = (event: any) => {
            const cardDetails = { creditCardProfileId: 0, cardNumber: "", tokenId: "", expiryYear: "", expiryMonth: "", nickName: "" };
            setCreditCardDetailNew(cardDetails);
            const objResponse = JSON.parse(event?.data);
            if ((objResponse?.errorMessage?.trim() != "" && objResponse?.errorCode != "0") || objResponse.message == "") {
                setIsValidCard(false);
            }
            else {
                handleErrorClose();
                setIsValidCard(true);
                const expiryYear = objResponse?.expiry?.slice(0, 4);
                const expiryMonth = objResponse?.expiry?.slice(4, objResponse?.expiry?.length);
                const nickName = '***' + objResponse?.token?.slice(objResponse?.token?.length - 4);
                const cardDetails = { creditCardProfileId: 0, cardNumber: objResponse.message, tokenId: objResponse.token, expiryYear: expiryYear, expiryMonth: expiryMonth, nickName: nickName };
                setCreditCardDetailNew(cardDetails);
            }
        };
        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    const saveCardDetails = () => {
        if (creditCardDetailNew?.tokenId && isValidCard && !isLoading) {
            setIsLoading(true);
            const model = {
                userAadId: azureADId,
                token: creditCardDetailNew?.tokenId,
                nickName: creditCardDetailNew?.nickName,
                expiryYear: creditCardDetailNew?.expiryYear,
                expiryMonth: creditCardDetailNew?.expiryMonth
            }
            partsservice.saveCreditCard(model)
                .then((response: any) => {
                    setIsLoading(false);
                    setShowAlert(true);
                    setErrorSuccessMessage(response.message);
                    if (response.creditCardProfileId > 0) {
                        getCreditCardList();
                        updatePaymentDetails({
                            ...stepperDetails?.payment,
                            creditCardProfileId: response.creditCardProfileId
                        });
                        setCreditCardDetailNew({ ...creditCardDetailNew, creditCardProfileId: response.creditCardProfileId });
                        setAlertType("success");
                    }
                    else {
                        setAlertType("error");
                    }
                })
                .catch((e: any) => {
                    setIsLoading(false);
                    setAlertType("error");
                    setShowAlert(true);
                    setErrorSuccessMessage(e);
                });
        }
    }

    const isAPILoading = creditCardList?.loading || customerCreditWarning?.loading || paymentOption?.loading || creditCardUrl?.loading || isLoading || creditCardUrl?.loading;

    return (
        <div className='paymentfullwidth_wrapper' ref={paymentDiv}>
            {isAPILoading && <Loader />}
            <div className="payment_Wrapper">
                <div className="firstlevel_wrapper">
                    {paymentOption?.data?.paymentOption?.map((item: any) =>
                        <div className="row mb-2" key={'div' + item.paymentTypeCode}>
                            <div className="col-12 col-md-12 col-xl-7">
                                <input onChange={onPaymentMethodChange} checked={stepperDetails?.payment?.paymentMethod == item.paymentTypeCode} value={item.paymentTypeCode} type="radio" disabled={(enableDropshipFlag ? !item.isEnabled : false)} className="select_radiobutton mr-3" name="paymentmethod" id={item.paymentTypeCode} />
                                <span className="selectshipping_label">{item.paymentTypeDesc}</span>
                            </div>
                        </div>
                    )}
                    {(stepperDetails?.payment?.error?.paymentMethod) && <Error> {String(t(RESOURCE.MyK_Label_SC_Payment_Method_Req))}</Error>}
                    {(stepperDetails?.payment?.paymentMethod?.toLowerCase() == PAYMENTMETHOD[PAYMENTMETHOD.AC].toLowerCase()) &&
                        <div className="row mb-2 mt-4">
                            <div className="col-12 col-md-12 col-lg-5 col-xl-4 ponumber">
                                <div>
                                    <span className="paymentmethod_label">{t(RESOURCE.MyK_Label_SC_PO_Number)}
                                        {paymentOption?.data?.isPoNumberRequired && <span className="mandatory">*</span>}
                                    </span>
                                </div>
                                <div>
                                    <input type="text" className="textbox" maxLength={32} value={stepperDetails?.payment?.poNumber} onChange={onChangePoNumber} />
                                </div>
                                {(stepperDetails?.payment?.error?.poNumber) && <Error> {String(t(RESOURCE.MyK_Label_SC_PoNumber_Req))}</Error>}
                            </div>
                        </div>
                    }
                    {(stepperDetails?.payment?.paymentMethod?.toLowerCase() == PAYMENTMETHOD[PAYMENTMETHOD.KC].toLowerCase()) &&
                        <>
                            <div className='row mt-4 paymentMethodCardContent'>
                                <div className="col-12 col-md-12 col-xl-7">
                                    <div className='paymentLabel'>{t(RESOURCE.MyK_Label_SC_Select_Payment_Method)}</div>
                                    <div className='paymentRadioContent'>
                                        {!isGuestUser && <div className='paymentRadio'>
                                            <input type="radio" onChange={onCreditCardOptionChange} className="select_radiobutton mr-3" checked={stepperDetails?.payment?.creditCardOption == CARDTYPE.EXISTINGCARD} value={CARDTYPE.EXISTINGCARD} name="creditcardoption" id="existingcard" />
                                            <span className="selectshipping_label">{t(RESOURCE.MyK_Label_SC_Pay_Card_On_Profile)}</span>
                                        </div>}
                                        <div className='paymentRadio'>
                                            <input type="radio" onChange={onCreditCardOptionChange} className="select_radiobutton mr-3" checked={stepperDetails?.payment?.creditCardOption == CARDTYPE.NEWCARD} value={CARDTYPE.NEWCARD} name="creditcardoption" id="newcard" />
                                            <span className="selectshipping_label">{t(RESOURCE.MyK_Label_SC_Add_New_Credit_Card)}</span>
                                        </div>
                                    </div>
                                    {(stepperDetails?.payment?.error?.creditCardProfileId) && <Error> {String(t(RESOURCE.MyK_Label_SC_CreditCard_Validation))}</Error>}
                                    {(stepperDetails?.payment?.creditCardOption == CARDTYPE.EXISTINGCARD) && <div className='paymentSelect'>
                                        <TreeviewDropdown
                                            className="col-8 col-md-8 col-xl-6"
                                            treeData={creditCardList?.data?.map((t: any) => ({ title: t.cardNumber, value: t.creditCardProfileId }))}
                                            onChange={onCreditCardSelect}
                                            value={stepperDetails?.payment?.creditCardProfileId > 0 ? stepperDetails?.payment?.creditCardProfileId : ""}
                                        />

                                    </div>}
                                </div>
                            </div>
                            <div className={stepperDetails?.payment?.creditCardOption == CARDTYPE.NEWCARD ? "mt-4" : "mt-4 hidden-visibility"}>
                                <div className="tokenform">
                                    {showAlert && (
                                        <Alerts
                                            messageAlert={errorSuccessMessage}
                                            alertType={alertType}
                                            time={60000} onClose={handleErrorClose}
                                        />
                                    )}
                                    <iframe id="tokenFrame" name="tokenFrame" className="iframestyle" src={creditCardUrl?.data} title="">
                                    </iframe>
                                    <button className={`primarybutton saveCard mb-2 ${(creditCardDetailNew?.tokenId && isValidCard) ? "" : "disabled"}`} disabled={!(creditCardDetailNew?.tokenId && isValidCard)} onClick={saveCardDetails} title={t(RESOURCE.MyK_Label_Save)}>{t(RESOURCE.MyK_Label_Save)}</button>
                                </div>
                            </div>

                            {(stepperDetails?.payment?.paymentMethod?.toLowerCase() == "kc") && <BillingInfo baseRef={props?.baseRef} isNextClick={props?.isNextClick} sameAsShipping={stepperDetails?.payment?.sameAsShipping} paymentDetails={stepperDetails?.payment} updatePaymentDetails={updatePaymentDetails} cartsDetails={props.cartsDetails} />}

                        </>
                    }

                    {((customerCreditWarning?.data?.customerCreditBalanceWarning ?? "") != "") &&
                        <div className="ErrorMessage_Wrapper mt-2">
                            {<div className="ErrorMessage_card">
                                <span className="fa fa-warning"></span> <span>{customerCreditWarning?.data?.customerCreditBalanceWarning}</span>
                            </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default Payment